import { useMemo, useState } from 'react';
import debounce from 'transmute/debounce';
import { stripDiacritics } from 'foundations-components/transitional/utils/Diacritics';
import UISelect from 'UIComponents/input/UISelect';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { shouldTrack } from '../../../utils/trackerUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export const PropertySelect = ({
  onSelectedOptionChange,
  onTrack,
  propertyOptions,
  testId
}) => {
  const optionsIncrement = 10;
  const [maxOptionsToShow, setMaxOptionsToShow] = useState(optionsIncrement);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const handleLoadMoreOptions = () => {
    setMaxOptionsToShow(maxOptionsToShow + 10);
  };
  const searchFilteredPropertyOptions = useMemo(() => propertyOptions.map(section => {
    return Object.assign({}, section, {
      options: section.options.filter(option => !searchValue ||
      // If no search value, show all options
      stripDiacritics(option.text.toLowerCase()).includes(searchValue.toLowerCase()) || stripDiacritics(option.value.toLowerCase()).includes(searchValue.toLowerCase()))
    });
  }), [propertyOptions, searchValue]);
  const filteredPropertyOptions = useMemo(() => searchFilteredPropertyOptions.map((section, index) => {
    const maxedOptions = section.options.slice(0, maxOptionsToShow);

    // Show the selected option first if it's not already in the list
    const hasSelectedOption = selectedOption && maxedOptions.some(option => option.value === selectedOption.value);
    const missingSelectedOption = selectedOption && !hasSelectedOption && propertyOptions[index].options.some(option => option.value === selectedOption.value);
    if (missingSelectedOption) {
      maxedOptions.unshift(selectedOption);
    } else if (hasSelectedOption) {
      maxedOptions.splice(maxedOptions.findIndex(option => option.value === selectedOption.value), 1);
      maxedOptions.unshift(selectedOption);
    }
    return Object.assign({}, section, {
      options: maxedOptions
    });
  }), [propertyOptions, searchFilteredPropertyOptions, maxOptionsToShow, selectedOption]);
  const shouldRenderShowMoreButton = useMemo(() => filteredPropertyOptions.some((section, index) => section.options.length < searchFilteredPropertyOptions[index].options.length), [filteredPropertyOptions, searchFilteredPropertyOptions]);
  const handleInputChange = input => {
    setSearchValue(input);
    setMaxOptionsToShow(optionsIncrement);
  };
  return /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": testId,
    dropdownFooter: shouldRenderShowMoreButton ? /*#__PURE__*/_jsx(UILink, {
      onClick: handleLoadMoreOptions,
      "data-test-id": 'show-more-button',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "createForecastTypeWizard.stepOne.showMoreOptions"
      })
    }) : null,
    menuStyle: {
      maxHeight: 320
    },
    onInputChange: debounce(300, handleInputChange),
    onSelectedOptionChange: event => {
      var _event$target, _event$target2;
      setSelectedOption(event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
      onSelectedOptionChange(event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 || (_event$target2 = _event$target2.value) === null || _event$target2 === void 0 ? void 0 : _event$target2.value);
      if (shouldTrack(onTrack)) {
        var _event$target3;
        onTrack === null || onTrack === void 0 || onTrack(event === null || event === void 0 || (_event$target3 = event.target) === null || _event$target3 === void 0 || (_event$target3 = _event$target3.value) === null || _event$target3 === void 0 ? void 0 : _event$target3.value);
      }
    },
    options: filteredPropertyOptions
  });
};